// extracted by mini-css-extract-plugin
export default {"image":"LinkComponent_image__9BHQ3","container":"LinkComponent_container__37L1z","link":"LinkComponent_link__Q5Xcq"};